export * from '@taqueria/protocol/out/types/HumanReadableIdentifier';
